module.exports = __webpack_public_path__ + "img/map_mediterrane-hoek.52f9dddb.png";